<script setup>
import { ref, defineProps, defineEmits } from 'vue'

const props = defineProps({
  value: String,
  readonly: Boolean,
  placeholder: String,
  style: String,
})

const model = defineModel()
const emit = defineEmits(['blur', 'change'])
const isEditing = ref(false)

function onClick() {
  if (isEditing.value) {
    return
  }
  isEditing.value = true
}

function onBlur() {
  if (!isEditing.value) {
    return
  }

  emit('blur')
  isEditing.value = false
}

function onChange(event) {
  emit('change', event.target.value)
}
</script>

<template>
  <input @click="onClick" @blur="onBlur" @keydown.enter="onBlur" @change="onChange" :readonly="!isEditing || readonly" type="text" v-model="model"
         :placeholder="props.placeholder"
         class="w-fit text-end overflow-y-auto border-white/20 resize-none h-fit placeholder-white/30 bg-transparent rounded-t-lg outline-0 focus-visible:outline-none"
         :class="style"
  />
</template>

